import { render, staticRenderFns } from "./SyncStatus.vue?vue&type=template&id=599ffb84&scoped=true&"
import script from "./SyncStatus.vue?vue&type=script&lang=js&"
export * from "./SyncStatus.vue?vue&type=script&lang=js&"
import style0 from "./SyncStatus.vue?vue&type=style&index=0&id=599ffb84&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "599ffb84",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
